import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";
import langEn from "./lang/en.json";
import langTh from "./lang/th.json";
import langLa from "./lang/la.json";

i18n
  .use(detector)
  .use(backend)
  .use(initReactI18next)
  .init({
    initImmediate: false,
    fallbackLng: "th",
    debug: true,
    resources: {
      en: {
        translation: langEn,
      },
      th: {
        translation: langTh,
      },
      la: {
        translation: langLa,
      },
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      wait: true,
      useSuspense: false,
    },
  } as any);

export default i18n;
